
export function NoteBoxViewConstructor(services, callbacks, context) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({
    isElementEditable: true,

    editElementModalController: [
      '$scope',
      '$mdDialog',
      'elementData',
      ($scope, $mdDialog, elementData) => {
        $scope.elementData = elementData;
        $scope.cancelDialog = $mdDialog.cancel;
        $scope.hideDialog = $mdDialog.hide;
      },
    ],
    editElementModalTemplate: `<angular-edit-note
      [element-data]="elementData"
      (hide-dialog)="hideDialog($event)"
      (cancel-dialog)="cancelDialog()"
      ></angular-edit-note>`,


    angularTemplate: '<div layout="column" class="note-content">{{ elementData.value }}</div>',


    initialize: function () {
      this.model.set("disableCopyLink", true);
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      this.model.attr({
        '.root-label': {
          fill: '#fff8c4',
        },
        'text': {
          fill: '#000',
        },
        '.body': {
          fill: '#fff8c4',
          'fill-opacity': 1,
        }
      });
    },

    checkSpecificDataBeforeDeleteBox: async function () {
      context.noteBoxesSet.delete(this.model.id);
      return Promise.resolve(true);
    }
  });
}
